import { Star24Filled, Star24Regular } from '@fluentui/react-icons';
import { useStarRatingStyles } from './StarRating.styles';

interface StarRatingProps {
  value: number;
  size?: number;
}

export function StarRating({ value, size = 16 }: StarRatingProps) {
  const styles = useStarRatingStyles();
  const clampedValue = Math.max(0, Math.min(5, value));
  const fullStars = Math.floor(clampedValue);
  const hasHalf = clampedValue - fullStars >= 0.25 && clampedValue - fullStars < 0.75;
  const emptyStars = 5 - fullStars - (hasHalf ? 1 : 0);

  return (
    <span className={styles.root} role="img" aria-label={`${clampedValue} out of 5 stars`}>
      {Array.from({ length: fullStars }, (_, i) => (
        <Star24Filled key={`full-${i}`} className={styles.filledStar} style={{ fontSize: size }} />
      ))}
      {hasHalf && (
        <span className={styles.starWrapper}>
          <Star24Regular className={styles.emptyStar} style={{ fontSize: size }} />
          <span className={styles.halfStarOverlay}>
            <Star24Filled style={{ fontSize: size }} />
          </span>
        </span>
      )}
      {Array.from({ length: emptyStars }, (_, i) => (
        <Star24Regular key={`empty-${i}`} className={styles.emptyStar} style={{ fontSize: size }} />
      ))}
    </span>
  );
}
